import axiosInstance from 'services/axiosMiddleware';

export async function deleteFeatureNotification(notificationid) {
  try {
    const response = await axiosInstance.post('/feature-notifications/delete-feature-notifications', { notificationid });

    if (response.data.status) {
      return response.data.message;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    console.error('Delete Notification Error:', error);
    throw error;
  }
}
